import { getCurrentTab } from './ui';

export const getSelectedLeaseIds = state => state.selectList.selectedLeaseIds;
export const getSelectedSaleIds = state => state.selectList.selectedSaleIds;

export const getSelectedIds = state => (
  getCurrentTab(state) === 'lease'
    ? getSelectedLeaseIds(state)
    : getSelectedSaleIds(state)
);
